import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { ButtonOutlined } from '../app-button/button'
import Spinner from '../spinner'

const styles = theme => ({
  email: {
    color: '#5856d6',
  },
  resendBtn: {
    maxWidth: 280,
    width: '100%',
    height: 40,
    marginTop: 22,
    padding: 0,
  },
})

const EmailResend = ({ classes, user, send, load }) => {
  return (
    <div className="boxResend">
      <Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
        {`Чтобы начать использовать систему, \n перейдите по ссылке в письме, \n высланном на адрес `}

        <span className={classes.email}>{user.email}</span>
      </Typography>

      <ButtonOutlined
        handleClick={() => send()}
        className={classes.resendBtn}
        color="secondary"
        text={load ? <Spinner stroke={'#8866ff'} /> : 'Выслать письмо повторно'}
      />
    </div>
  )
}

export default withStyles(styles)(EmailResend)
